__turbopack_context__.v({
  "actionButton": "styles-module-scss-module__mdoYrG__actionButton",
  "close": "styles-module-scss-module__mdoYrG__close",
  "closeContainer": "styles-module-scss-module__mdoYrG__closeContainer",
  "description": "styles-module-scss-module__mdoYrG__description",
  "entityContent": "styles-module-scss-module__mdoYrG__entityContent",
  "entityHeader": "styles-module-scss-module__mdoYrG__entityHeader",
  "entityHeaderInfo": "styles-module-scss-module__mdoYrG__entityHeaderInfo",
  "entityImagePlaceholder": "styles-module-scss-module__mdoYrG__entityImagePlaceholder",
  "entityInitial": "styles-module-scss-module__mdoYrG__entityInitial",
  "entityLink": "styles-module-scss-module__mdoYrG__entityLink",
  "entityLinks": "styles-module-scss-module__mdoYrG__entityLinks",
  "entityLogoImage": "styles-module-scss-module__mdoYrG__entityLogoImage",
  "entityName": "styles-module-scss-module__mdoYrG__entityName",
  "entityNameRow": "styles-module-scss-module__mdoYrG__entityNameRow",
  "entitySubtitle": "styles-module-scss-module__mdoYrG__entitySubtitle",
  "latestItemsSection": "styles-module-scss-module__mdoYrG__latestItemsSection",
  "metaChip": "styles-module-scss-module__mdoYrG__metaChip",
  "rentalBadge": "styles-module-scss-module__mdoYrG__rentalBadge",
  "slideIn": "styles-module-scss-module__mdoYrG__slideIn",
  "titleInHeader": "styles-module-scss-module__mdoYrG__titleInHeader",
  "vendorMeta": "styles-module-scss-module__mdoYrG__vendorMeta",
});
